namespace $.$$ {

	export class $shm_hitalama_map_widget_float_chart extends $.$shm_hitalama_map_widget_float_chart {
		
		@ $mol_mem
		chart() {
			return this.widget().chart()!
		}

		@ $mol_mem
		gap_left( next?: number ): number {
			return this.chart().Gap_left(next)?.val(next) ?? 60
		}

		names(): string[] {
			return [ ...this.traversed().by_group.keys() ]
		}

		@ $mol_mem_key
		series_y( group_name: any ): readonly ( any )[] {
			const labels = this.labels()

			const by_label = this.traversed().by_group.get( group_name )

			return labels.map( l => Number( by_label?.get( l ) ) )
		}

		labels(): readonly ( string )[] {
			return [...this.traversed().labels]
		}

		@ $mol_mem
		traversed() {
			return this.chart().traversed()
		}
		
		@ $mol_action
		settings_add() {
			this.widget().settings_widget_enabled( true )

			this.Map_page().contextmenu_showed( false )
		}

		@ $mol_action
		filter_add( name: string ) {
			const pos = this.Map_page().get_pointer_pos()

			const widget = this.map().widget_add( 'chart_filter', pos, 180, 290 )
			widget?.text( name )
			widget?.Chart(null)?.remote( this.chart() )

			this.Map_page().contextmenu_showed( false )
		}

		filter_buttons() {
			return this.chart().table_head().map( name => this.Filter_add( name ) )
		}

		filter_name( id: any ): string {
			return id
		}

	}

}
